// extracted by mini-css-extract-plugin
export default {"cls1":"Fdcl1sblYLDc02kh_n7x","cls2":"zIDVmDY0YSk6JFaxTwMP Fdcl1sblYLDc02kh_n7x"};